/**Import react section */
import React, { useState } from 'react'
/**Import common componets */
import TextBox from './../../../common/TextBox'
import ButtonConfirm from './../../../common/Buttons/ButtonConfirm'
/**Import MaterialUi section */
import { Grid } from '@material-ui/core'
import { createServicesStyle } from '../../../../resources/styles/CreateServiceStyles'
import DateSelector from '../../../common/DateSelector'
const SuspendedService = (props) => {
	const { onSetPasswordDialogConfiguration, IsClosed } = props
	const classes = createServicesStyle()
	const [suspendedModel, setSuspendedModel] = useState({ comments: '', status: props.status, futureCareDate: null })

	const openModalForSuspendedService = () => {
		if (onSetPasswordDialogConfiguration) onSetPasswordDialogConfiguration(suspendedModel)
	}

	/**On change properties */
	const onPropertyChange = (event) => {
		let { name, value } = event.target
		setSuspendedModel({
			...suspendedModel,
			[name]: value
		})
	}

	/**Verify if can be sabed */
	const canBeSaved = () => {
		if (suspendedModel ? suspendedModel.comments.length <= 0 : true) return false
		if (suspendedModel && suspendedModel.futureCareDate ? suspendedModel.futureCareDate.length <= 1 : true) return false
		return true
	}

	return (
		<div>
			<Grid item xs={12}>
				<DateSelector
					dataCy='data-picker-future-care-date'
					label='Future care date'
					name='futureCareDate'
					active={true}
					value={suspendedModel ? suspendedModel.futureCareDate : null}
					onChange={onPropertyChange}
					disabled={false}
					showIncon={false}
				/>
			</Grid>
			<Grid item xs={12}>
				<TextBox
					active={true}
					fullWidth
					autoFocus
					disabled={IsClosed}
					name='comments'
					variant='outlined'
					margin='dense'
					label='REASON FOR SUSPENSION'
					multiline
					rows={4}
					onChange={onPropertyChange}
					value={suspendedModel ? suspendedModel.comments : ''}
				/>
			</Grid>
			{!IsClosed && (
				<Grid item xs={12} className={classes.updateButton}>
					<ButtonConfirm title='CONFIRM' isSaving={!canBeSaved()} onSavedClick={openModalForSuspendedService} />
				</Grid>
			)}
		</div>
	)
}

export default SuspendedService
